import Filter from "./Filter";
import ListData from "./ListData";
import TableData from "./TableData";
import ViewItem from "./ViewItem";

const securityEAViewComponents = {
  Filter,
  ListData,
  TableData,
  ViewItem
}

export default securityEAViewComponents